import postMessageService from '@/modules/common/services/postMessageService'

const AnalyticsPlugin = {
    install(Vue, options) {
        Vue.prototype.$track = (eventName, options = {}) => {
            postMessageService.post('analyticsEvent', {eventName, options})
        };
    }
};
  
export default AnalyticsPlugin;